// import { categories, classification } from '@/api/project';
import { fetch } from '@/api/model';
import { handleError } from '@/actions/common';
import projectSlice from '@/state/project.slice';
import store from '@/state/store';
import processModels from './process-models';

export default async (id: string): Promise<void> => {
  try {
    const models = await fetch(id, true);
    store.dispatch(projectSlice.actions.updated({
      code: id,
      ...processModels(models),
    }));
  } catch (error) {
    handleError(error);
  }
};
